// Port of api/fuel/app/classes/filter/search/games/filters/query/game/version/size/depth.php
import { rangeActive } from 'offline/filter/core/search/unit'
export default {
	name: 'version.size.depth',
	priority: 65,
	require: function(config, filter) { return filter.version && filter.version.size && rangeActive(filter.version.size.depth, 0, 9999) },
	run: function(config, filter, data, query) {
		if (filter.version.size.depth.from > 0) query.where('v.game_version_storage_depth', '>=', filter.version.size.depth.from)
		if (filter.version.size.depth.to < 9999) query.where('v.game_version_storage_depth', '<=', filter.version.size.depth.to)
	}
}
